import { render } from "./Residues.vue?vue&type=template&id=f0dc9548"
import script from "./Residues.vue?vue&type=script&lang=js"
export * from "./Residues.vue?vue&type=script&lang=js"

import "./Residues.vue?vue&type=style&index=0&id=f0dc9548&lang=css"
script.render = render

export default script